import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import { getAuth } from "firebase/auth";
import { app } from '../config/app.js';

export const downloadPdf = async (reportRef,filename,params) => {
    const element = reportRef.current;
   // const canvas = await html2canvas(element);
   // const imgData = canvas.toDataURL("image/png");

    const canvas = await html2canvas(element, {
        backgroundColor: "#ffffff",
      });
    const imgData = canvas.toDataURL("image/jpeg", 1);
    
  
    const pdf = new jsPDF(params);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
 //   console.log("pdfWidth",pdfWidth);
   // console.log("pdfHeight",pdfHeight);
    pdf.addImage(imgData, "JPEG", 5, 5, pdfWidth, pdfHeight);
    pdf.save(filename);
};


export const convertDatetime = (datetime) => {
  // Se datetime è già un oggetto Date, restituiscilo direttamente
  if (datetime instanceof Date) {
    return datetime;
  }

  // Altrimenti, è un oggetto con seconds e nanoseconds
  if (datetime && datetime.seconds !== undefined && datetime.nanoseconds !== undefined) {
    const millis = datetime.seconds * 1000 + datetime.nanoseconds / 1_000_000;
    return new Date(millis);
  }

  // Se datetime non è valido, restituisci null o una data di fallback
  return null;
};

export const remoteLog = (type,message) => {
  let url=app.externalLogService;
  const lastLogDate=app.log.lastLogDate;
  const auth = getAuth();
  const currentUser = auth.currentUser;

  console.log("Log request", currentUser);
  // get user uid and email
  app.log.currentArray.push({
    "type": type,
    "message": message,
    "timestamp": new Date().toISOString(),    
    "user": currentUser,
    "userAgent": navigator.userAgent,
    "appVersion": app.version,
    "path": window.location.href,

  });
  //console.log("Preparato log ", app.log.currentArray);
  const minimumLogTrasmissionInterval=app.log.minimumLogTrasmissionInterval;

  if (lastLogDate && (new Date() - lastLogDate) < minimumLogTrasmissionInterval) {
    return;
  }
  // call url with logObject as body
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(app.log.currentArray),
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });
  app.log.lastLogDate=new Date();
  app.log.currentArray=[];
};